// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld-base';
import './baseTracePane';

myw.TraceFindRoutePane = myw.BaseTracePane.extend({
    className: 'trace-find-route-pane',
    messageGroup: 'TracePlugin',

    render() {
        myw.BaseTracePane.prototype.render.call(this);
        const self = this;
        const valid = this.from && this.to && this.network;

        const fromTitle = (this.from && this.from.getTitle()) || '';

        const form = new myw.Form({
            messageGroup: 'TracePlugin',
            rows: [
                {
                    label: '{:from_label}:',
                    components: [
                        new myw.Input({
                            value: fromTitle,
                            disabled: true,
                            style: `flex: 1; min-width: ${fromTitle.length * 7.7}px`
                        }),
                        new myw.PrimaryButton({
                            text: '{:set_button_title}',
                            disabled: !this.options.app.currentFeature,
                            onClick: () => {
                                const feature = this.options.app.currentFeature;
                                if (!feature) {
                                    alert(this.msg('select_feature_error_msg'));
                                    return;
                                }
                                this.app.setCurrentFeature(feature);
                                this.owner.fire('tracePlugin-setFromFeature', { feature: feature });
                            }
                        })
                    ]
                },
                {
                    label: '{:to_label}:',
                    components: [
                        new myw.Input({
                            value: (this.to && this.to._myw.title) || '',
                            disabled: true,
                            style: `flex: 1; min-width: ${((this.to && this.to._myw.title.length) ||
                                0) * 7.7}px`
                        }),
                        new myw.PrimaryButton({
                            text: '{:set_button_title}',
                            disabled: !this.options.app.currentFeature,
                            onClick: () => {
                                const feature = this.options.app.currentFeature;
                                if (!feature) {
                                    alert(this.msg('select_feature_error_msg'));
                                    return;
                                }
                                this.app.setCurrentFeature(feature);
                                this.owner.fire('tracePlugin-setToFeature', { feature: feature });
                            }
                        })
                    ]
                },
                {
                    label: '{:network_label}:',
                    components: [
                        new myw.Dropdown({
                            options: (this.state && this.state.availableNetworks) || [],
                            disabled: !(this.state && this.state.availableNetworks.length),
                            placeholder: !(this.state && this.state.availableNetworks.length)
                                ? '{:no_networks}'
                                : null,
                            selected: this.network,
                            cssClass: 'large',
                            onChange: input => {
                                self.network = input.getValue();
                                this.render();
                            }
                        })
                    ]
                },
                {
                    label: '{:max_dist_label}:',
                    components: [
                        new myw.UnitInput({
                            unitScaleDef: this.app.system.settings['core.units'].length,
                            defaultUnit: myw.applicationDefinition.displayUnits.length,
                            cssClass: 'medium',
                            value: this.maxDist,
                            onChange: function(input) {
                                try {
                                    self.maxDist = input.getUnitValue().toString();
                                    self.maxDistScaled = input.getUnitValue().valueIn('m');
                                } catch (e) {
                                    self.maxDist = input.getValue();
                                    self.maxDistScaled = null;
                                }
                            }
                        })
                    ]
                }
            ],
            bottomLeft: [
                new myw.PrimaryButton({
                    text: '{:trace_button_title}',
                    disabled: !valid,
                    loading: this.loading,
                    onClick: () => {
                        this.doTrace();
                    }
                }),
                this.messageType != 'error'
                    ? `<span style="margin-left: 10px">${this.message}</span>`
                    : ''
            ],
            bottomRight: [
                new myw.PrimaryButton({
                    id: 'zoomTo',
                    title: '{:zoom_to_results_tip}',
                    disabled: this.app.currentFeatureSet.items.length == 0,
                    onClick: () => {
                        this.app.map.fitBoundsToFeatures(this.app.currentFeatureSet.items);
                    }
                }),
                new myw.PrimaryButton({
                    id: 'clearResults',
                    title: '{:clear_selections_tip}',
                    disabled: this.app.currentFeatureSet.items.length == 0,
                    onClick: () => {
                        this.options.app.clearResults();
                        this.message = '';
                        this.render();
                    }
                })
            ]
        });
        this.$el.append(form.$el);
    },

    doTrace() {
        const self = this;
        this.options.app.clearResults();
        self.owner.fire('tracePlugin-traceStarted', { origin: 'dialog' });
        this.from.datasource
            .shortestPath(this.network, this.from, this.to.getUrn(), {
                resultType: 'tree',
                maxDist: this.maxDistScaled
            })
            .then(res => {
                if (res.items.length) {
                    self.options.app.setCurrentFeatureSet(res, null, false);
                    self.options.app.map.fitBoundsToFeatures(
                        self.options.app.currentFeatureSet.items
                    );
                    const keys = Object.keys(res.nodes);
                    const totalDist = res.nodes[keys[keys.length - 1]].dist;
                    const message = `${res.items.length} ${self.msg(
                        'found_msg'
                    )} (${self.formatDistance(totalDist)})`;
                    self.owner.fire('tracePlugin-traceComplete', { msg: message, type: 'info' });
                    return;
                }
                self.owner.fire('tracePlugin-traceComplete', {
                    msg: self.msg('no_results'),
                    msgType: 'info'
                });
            })
            .catch(err => {
                console.log(err.stack);
                self.owner.fire('tracePlugin-traceComplete', {
                    msg: err.message,
                    msgType: 'error'
                });
            });
    }
});

export default myw.TraceFindRoutePane;
